import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function AcceptanceReport() {
  const { data, isLoading, isError, refetch } = useQuery({ queryKey: ["legal-acceptance"], queryFn: async () => (await api.get("/admin/legal-acceptance")).data });
  if (isLoading) return <p className="text-sm text-[#A88B7D]">Loading acceptance report…</p>;
  if (isError) return <p role="alert" className="text-sm text-[#8C2A2A]">Couldn't load the acceptance report. <button className="underline" onClick={() => refetch()}>Retry</button></p>;
  return (
    <div className="rounded-2xl border border-[#E6DBCF] bg-[#FDFBF7] p-6" data-testid="acceptance-report">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <h3 className="text-2xl font-semibold text-[#2C1810]">Acceptance report</h3>
        <button onClick={() => refetch()} data-testid="acceptance-refresh" className="min-h-[40px] rounded-full border border-[#E6DBCF] px-4 text-xs font-semibold text-[#2C1810] hover:bg-[#F6F1EA]">Refresh</button>
      </div>
      <p className="mt-1 text-sm text-[#6E5549]">{data.total_artists} artists in total.</p>
      <div className="mt-5 grid gap-3 sm:grid-cols-2">
        {data.docs.map((d) => {
          const pct = data.total_artists ? Math.round((d.accepted / data.total_artists) * 100) : 100;
          return (
            <div key={d.kind} className="rounded-xl bg-white p-4" data-testid={`acceptance-${d.kind}`}>
              <p className="text-sm font-semibold text-[#2C1810]">{d.title} · v{d.version}</p>
              <p className="mt-1 text-xs text-[#6E5549]"><span data-testid={`acceptance-${d.kind}-accepted`}>{d.accepted}</span> accepted · <span data-testid={`acceptance-${d.kind}-pending`}>{d.pending}</span> not yet</p>
              <div className="mt-2 h-1.5 rounded-full bg-[#E6DBCF]"><div className="h-1.5 rounded-full bg-[#C5A059]" style={{ width: `${pct}%` }} /></div>
            </div>
          );
        })}
      </div>
      <h4 className="mt-6 text-[11px] font-semibold uppercase tracking-[0.18em] text-[#6E5549]">Artists who haven't accepted the latest version</h4>
      <ul className="mt-2 max-h-80 divide-y divide-[#E6DBCF] overflow-y-auto rounded-xl border border-[#E6DBCF] bg-white" data-testid="acceptance-pending-list">
        {data.pending_users.map((u) => (
          <li key={u.id} className="flex flex-wrap items-center gap-x-3 gap-y-1 px-4 py-3 text-sm">
            <span className="min-w-0 flex-1 truncate text-[#2C1810]">{u.name ? `${u.name} · ` : ""}{u.email}</span>
            <span className="text-xs text-[#6E5549]">{u.pending.map((p) => `${p.title} (has v${p.accepted_version}, needs v${p.current_version})`).join(" · ")}</span>
          </li>
        ))}
        {!data.pending_users.length && <li className="px-4 py-3 text-sm italic text-[#2E6B4F]" data-testid="acceptance-all-current">Everyone has accepted the latest versions.</li>}
      </ul>
    </div>
  );
}
